import { FC } from 'react';
import { useLocation, useParams, useHistory } from 'react-router-dom';
import { FieldPath, FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Content } from '@/components/layout/Content';
import { useMutation } from '@/hooks/graphql/useMutation';
import { useNotify } from '@/hooks/useNotify';
import { eachValidationErrorsForHookFrom, ServerValidationError } from '@/hooks/graphql/error/ServerValidationError';
import { parseBackUrl } from '@/utils/url';
import { Form } from '../edit/parts/Form/Form';
import {
  CREATE_REGULAR_HEALTH_CHECKUP_RESULT,
  CreateRegularHealthCheckupResultQueryVariables,
  CreateRegularHealthCheckupResultQueryResult,
  convertFormDataToQueryVariables
} from './query';
import { Schema, schema, defaultValues } from '../edit/schema';

interface SearchParams {
  personalId: string;
}

export const CreatePersonalResult: FC = () => {
  const location = useLocation();
  const { personalId } = useParams<SearchParams>();
  const history = useHistory();
  const notify = useNotify();

  const methods = useForm<Schema>({
    defaultValues,
    resolver: yupResolver(schema)
  });
  const { handleSubmit, setError } = methods;

  const [createRegularHealthCheckupResult] = useMutation<
    CreateRegularHealthCheckupResultQueryResult,
    CreateRegularHealthCheckupResultQueryVariables
  >(CREATE_REGULAR_HEALTH_CHECKUP_RESULT);

  const onSubmit: SubmitHandler<Schema> = async data => {
    try {
      const res = await createRegularHealthCheckupResult({
        variables: convertFormDataToQueryVariables(data, personalId)
      });

      notify('作成しました', 'success');
      history.push(
        `/regular_health_checkup/personal_results/${personalId}/${res?.data?.createRegularHealthCheckupResult?.regularHealthCheckupResult?.id}`
      );
    } catch (err) {
      if (err instanceof ServerValidationError) {
        eachValidationErrorsForHookFrom(err.validationErrors, schema, data, (path, error) => {
          setError(path as FieldPath<Schema>, error);
        });
        return;
      }
      throw err;
    }
  };

  return (
    <FormProvider {...methods}>
      <div className="l-title-wrap">
        <h1 className="m-title-main">個人結果</h1>
      </div>
      <Content size="xl">
        <Form
          personalId={personalId}
          onSubmit={handleSubmit(onSubmit)}
          onCancel={() =>
            history.push(parseBackUrl(location, `/regular_health_checkup/personal_results/${personalId}`))
          }
        />
      </Content>
    </FormProvider>
  );
};
